import type { Feature } from '@luna/gatekeeper';

export const prepaidCardInfo: Feature = {
    enabled: false,
    _description: 'Displays prepaid info card in the functions page',
};
